// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__h3Le9","title":"LoginPage_title__RBt-o","submit":"LoginPage_submit__LcAvv"};